import { getFetcher } from "./base"

export const subscribeToNewsLetter = (email: string) =>
  getFetcher().post<{}>("/v1/subscribe-to-newsletter", { email })
